import React from 'react';
import PropTypes from 'prop-types';
import Group from '../Group/Group';
import Label from '../Label/Label';
import EmployerIdentificationNumberInput from '../EmployerIdentificationNumberInput';

const EmployerIdentificationNumberField = ({ label, value, onChange }) => (
    <Group>
        <Label>{label}</Label>
        <EmployerIdentificationNumberInput value={value} onChange={onChange} />
    </Group>
);

EmployerIdentificationNumberField.defaultProps = {
    label: 'Employer Identification Number (EIN)',
};

EmployerIdentificationNumberField.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
};

export default EmployerIdentificationNumberField;
